import { DatiqButtonSizes, DatiqButtonTypes } from '@dat/datiq-components-pkg/button';
import z from 'zod';

const IqCellActionTooltipSchema = z.object({
    id: z.string(),
    type: z.enum([ 'Info' ]),
    title: z.string(),
    description: z.string(),
    icon: z.string(),
    hideIcon: z.boolean(),
    openOnClick: z.boolean()
});

const IqCellActionBaseSchema = z.object({
    id: z.string().optional(),
    action: z.object({
        name: z.string(),
        payload: z.any()
    }).required(),
    disabled: z.boolean(),
    tooltip: IqCellActionTooltipSchema.optional(),
    disabledTooltip: IqCellActionTooltipSchema.optional()
});

const IqCellActionButtonSchema = z.object({
    id: z.string(),
    type: z.nativeEnum(DatiqButtonTypes),
    size: z.nativeEnum(DatiqButtonSizes),
    label: z.string(),
    props: z.unknown(),
    disabled: z.boolean(),
    icon: z.string()
});

const IqCellActionTypeSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('icon'), icon: z.string() }),
    z.object({ type: z.literal('button'), button: IqCellActionButtonSchema })
]);

export const IqCellActionSchema = z.intersection(IqCellActionBaseSchema, IqCellActionTypeSchema);

/*****/

export type IDatiqCellAction = z.infer<typeof IqCellActionSchema>;
